import React from 'react';
import {connect} from 'react-redux';
import Container from '../components/Container';
import ParseHTML from '../components/ParseHTML';

if (process.env.BROWSER) {
    require('flexboxgrid');
}

const Slider = React.createClass({
    propTypes: {
        hidden: React.PropTypes.bool.isRequired,
        images: React.PropTypes.array,
        title: React.PropTypes.string,
        columns: React.PropTypes.number
    },
    componentDidMount: function() {
        this._renderSwiper();
    },
    componentDidUpdate: function() {
        this._renderSwiper();
    },
    _renderSwiper: function() {
        window.myImageSwiper = new Swiper(this.refs.slider, {
            height: 380,
            direction: 'horizontal',
            effect: 'coverflow',
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: this.props.columns,
            slidesPerGroup: 1,
            loop: true,
            coverflow: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true
            },
            nextButton: this.refs.next,
            prevButton: this.refs.prev,
            pagination: this.refs.pagination,
            paginationType: 'custom',
            paginationClickable: true,
            paginationCustomRender: function(swiper, current, total) {
                var pagers = '';
                for (var items = 1; items <= total; items++) {
                    if (items == current) {
                        for (let i = 0; i < swiper.params.slidesPerGroup; i++) {
                            pagers +=
                                '<span onClick="window.myImageSwiper.slideTo(' +
                                items * swiper.params.slidesPerGroup +
                                ')" class="pagination-bullet active"></span>';
                        }
                    } else {
                        for (let i = 0; i < swiper.params.slidesPerGroup; i++) {
                            pagers +=
                                '<span onClick="window.myImageSwiper.slideTo(' +
                                items * swiper.params.slidesPerGroup +
                                ')" class="pagination-bullet"></span>';
                        }
                    }
                }
                return pagers;
            },
            breakpoints: {
                500: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetweenSlides: 15,
                    pagination: null
                },
                650: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetweenSlides: 15
                },
                840: {
                    slidesPerView: this.props.columns < 2 ? this.props.columns : 2,
                    slidesPerGroup: this.props.columns < 2 ? this.props.columns : 2,
                    spaceBetweenSlides: 15
                },
                1120: {
                    slidesPerView: this.props.columns < 3 ? this.props.columns : 3,
                    slidesPerGroup: this.props.columns < 3 ? this.props.columns : 3,
                    spaceBetweenSlides: 15
                }
            }
        });
    },
    _open: function(index) {
        this.setState({
            openItem: index
        });
    },
    render: function() {
        return (
            <section>
                <Container>
                    <div style={{marginTop: '100px'}} className="image-slider">
                        <div>
                            <h2>
                                <ParseHTML>{this.props.title}</ParseHTML>
                            </h2>
                            <div className="swiper-container" ref="slider">
                                <div className="swiper-wrapper">
                                    {this.props.images.map((item, index) => {
                                        return (
                                            <div
                                                className="swiper-slide image-slider-image"
                                                key={index}
                                            >
                                                <img src={item} />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div ref="prev" className="swiper-button-prev" />
                            <div ref="next" className="swiper-button-next" />
                            <div ref="pagination" className="swiper-pagination" />
                        </div>
                    </div>
                </Container>
            </section>
        );
    }
});

const mapStateToProps = state => {
    return {
        title: state.image_slider_employees.title,
        hidden: state.image_slider_employees.hidden,
        images: state.image_slider_employees.images,
        columns: state.image_slider_employees.images_per_page
    };
};

export default connect(mapStateToProps)(Slider);



// WEBPACK FOOTER //
// ./src/js/containers/ImageSliderEmployees.js